import request from '@/utils/request'
import { apiConsolelog } from '@/utils/tracelog'

export function getStatistics () {
  apiConsolelog('api: getStatistics()')

  return request({
    url: '/counter/show',
    method: 'get'
  })
}
